import { render, staticRenderFns } from "./DestinatariReport.vue?vue&type=template&id=1cd96378&"
import script from "./DestinatariReport.vue?vue&type=script&lang=js&"
export * from "./DestinatariReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports